import React from 'react'
import PropTypes from 'prop-types'
import {Heading as HecHeading} from '@/components/ui/heading'
import {cn} from '@/lib/utils'

const Heading = ({tag, variant, content, attributes, className}) => {
    const {className: attrClassName, ...restAttr} = attributes || {}
    return (
        <HecHeading
            tag={tag}
            variant={variant}
            className={cn(className, attrClassName)}
            {...restAttr}
            data-testid="heading-HecHeading"
        >
            {content}
        </HecHeading>
    )
}

export default Heading

Heading.propTypes = {
    tag: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    attributes: PropTypes.object,
    className: PropTypes.object
}

export const HeadingDefinition = {
    component: Heading,
    name: 'Heading',
    noWrap: true,
    inputs: [
        {
            name: 'tag',
            type: 'string',
            enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'span', 'p'],
            defaultValue: 'h1'
        },
        {
            name: 'variant',
            type: 'string',
            enum: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
            defaultValue: 'h1'
        },
        {
            name: 'content',
            type: 'longText',
            defaultValue: 'Heading'
        }
    ]
}
